import {Component, computed, effect, input, model, output} from '@angular/core';
import {MatCheckbox} from "@angular/material/checkbox";
import {NgScrollbar} from "ngx-scrollbar";
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from "@angular/material/expansion";
import {standardsGroup} from "../team-management.component";

@Component({
  selector: 'app-member-assignment-to-standards',
  imports: [
    MatCheckbox,
    NgScrollbar,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
  ],
  templateUrl: './member-assignment-to-standards.component.html',
  styleUrl: './member-assignment-to-standards.component.scss'
})
export class MemberAssignmentToStandardsComponent {
  groups = model.required<standardsGroup[]>();
  fullAccess = input.required<boolean>();
  checkedAllStandards = computed(() => {
    return this.groups().every(t => t.checked);
  })
  groupsChange = output<standardsGroup[]>();

  constructor() {
    effect(() => {
      if( this.fullAccess() ) {
        this.groups().forEach(group => {
          group.checked = true;
          group.standards.forEach(standard => standard.checked = true);
        });
      }
    });
  }

  readonly partiallyComplete = computed(() => {
    const allGroups = this.groups();
    if (!allGroups || allGroups.length === 0) {
      return false;
    }
    allGroups.forEach((group) => {
      group.intermediate = group.standards.some(t => t.checked) &&
        !group.standards.every(standard => standard.checked);
    });
    return allGroups.some(t => t.checked) &&
      !allGroups.every(t => t.checked) &&
      !allGroups.every(group => group.standards.every(standard => standard.checked));
  });

  update(checked: boolean, index?: number, subIndex?: number) {
    this.groups.update( groups => {
      if (index === undefined) { //all
        groups?.forEach(group => {
          group.checked = checked;
          group.standards.forEach(standard => standard.checked = checked);
        });
      } else { //group or standard
        if (subIndex !== undefined) { //standard
          groups![index].standards[subIndex].checked = checked;
          groups![index].checked = groups![index].standards.every(t => t.checked);
        } else { //group
          groups![index].checked = checked;
          groups![index].standards.forEach(standard => standard.checked = checked);
        }
      }
      return [...groups];
    });
    this.groupsChange.emit(this.groups());
  }
}
